import React from 'react';

type Props = {
  title: string
}

export function NoDataComponent(props: Props): JSX.Element {
  const { title } = props;

  return (
    <div className="no-data-component py-5 text-center">
      <h1 className="font-weight-light">{title}</h1>
    </div>
  )
}
